import { Module } from 'wrapper6'
import Lightbox from '../utils/_lightbox'

const $ = jQuery

export default class CoverGallery extends Module {
  ready (app) {
    const lightbox = new Lightbox('.mtt-product-gallery__media.is-image')
  }
}
